import { useEffect } from "react";
import { Host } from "../../../yoello-lib/modules/host/Hosts";
import { setTitle } from "../state/signup.action";
import { titles } from "../state/Titles";
import { ESignupStages } from "../types";



export function useSignupTitle(dispatch: any, stage: ESignupStages, host: Host) {
    useEffect(() => {
        if(titles[host]){
            dispatch(setTitle(titles[host][stage]));
        }else{
            dispatch(setTitle(titles["partners"][stage]));
        }
        
        // eslint-disable-next-line
    }, [stage])
}